export default {"src":"/_next/static/media/vittalBg.62b7421d.svg","height":420,"width":447};